import { useState, useEffect, useContext } from 'react';
import { A01, A01Output } from '../../api/U003';
import { AppContext } from 'templates/AppContextProvider';

export function useGetNotifications(
  lang: string
): [A01Output['notifications'], boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(true);
  const [notifications, setNotifications] = useState<A01Output['notifications']>([]);
  const [err, setError] = useState<Error | null>(null);
  const ctx = useContext(AppContext);

  const FetchNotifications = async (userId: string, lang: string, cancellation: AbortSignal) => {
    const json = await A01(userId, lang, cancellation);
    return json.notifications.map(
      (obj: {
        notice_id: number;
        start_dtm: string;
        notice_title: string;
        notice: string;
        file1: string | null;
        file2: string | null;
        file3: string | null;
        file4: string | null;
        file5: string | null;
      }) => {
        return {
          notice_id: obj.notice_id,
          start_dtm: new Date(obj.start_dtm),
          notice_title: obj.notice_title,
          notice: obj.notice,
          file1: obj.file1 ?? undefined,
          file2: obj.file2 ?? undefined,
          file3: obj.file3 ?? undefined,
          file4: obj.file4 ?? undefined,
          file5: obj.file5 ?? undefined,
        };
      }
    );
  };

  useEffect(() => {
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      if (!ctx.userId) return;
      try {
        setLoading(true);
        setError(null);
        const notifications = await FetchNotifications(ctx.userId, lang, cancellation);
        setNotifications(notifications);
      } catch (err) {
        if (err instanceof DOMException && err.message === 'signal is aborted without reason')
          return;
        if (err instanceof Error) {
          setError(err);
        } else {
          setError(new Error(`unknown error. ${err}`));
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      controller.abort();
    };
  }, [ctx.userId, lang]);

  return [notifications, loading, err];
}
